import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AdminService } from 'src/app/services/admin/admin.service';

@Component({
  selector: 'app-add-result-template',
  templateUrl: './add-result-template.component.html',
  styleUrls: ['./add-result-template.component.scss']
})
export class AddResultTemplateComponent implements OnInit {
 letterPattern = /^[a-zA-Z ]*$/;
  templateName = new FormControl('', [Validators.required,this.noWhitespaceValidator, Validators.pattern(this.letterPattern)]);
  url = new FormControl('', [Validators.required,this.noWhitespaceValidator]);

  constructor(public dialogRef: MatDialogRef<AddResultTemplateComponent>,
    private adminService : AdminService) { }

  ngOnInit() {
  }
  closeDialog() {
    this.dialogRef.close(null);
  }

  getErrorMessage(feild) {
    // console.log(feild);
    
    switch (feild) {
      case 'Template Name':
        return this.templateName.hasError('required') ? 'Enter Template Name' :
          this.templateName.hasError('pattern') ? 'Enter Alphabet Only' :
          this.templateName.hasError('whitespace')?'Please provide valid Template Name': '';

      case 'Template Url':
        return this.url.hasError('required') ? 'Enter Url' :
        this.templateName.hasError('whitespace')?'Please provide valid Template Url': '';

      default:
        break;
    }

  }

  submit() {
   
  //   let templateData = {
  //     routeUrl: this.url.value,
  //     templateName: this.templateName.value
  //   }
  //  let options= {
  //    purpose:'​template',
  //    data:templateData
  //  }
  //   this.adminService.postWithTokens(options).subscribe(
  //     response => {
  //       console.log("response after adding template: ", response);
  //       this.dialogRef.close("Added");        
  //     },
  //     error => {
  //       console.log("error after adding template: ", error);
  //     }
  //   )

  
  }


 

  public noWhitespaceValidator(control: FormControl) {
    // console.log('value', control.value);

    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

}
